import React from "react";
import { useSelector } from "react-redux";
import { selectors } from "reducers/patient-outreaches";

// S3DEV2-7602 — Tiles are presentation-only. Counts honor the same filters as the grid
// (see actions/patient-outreaches.fetchPatientOutreachCounts + BE
// PatientOutreachAdminSerializer.Counts). Click-to-filter behavior was removed since
// FilterBar already exposes an Outreach State picker.
export const TILES = [
  { label: "Total matching filters", field: "totalInTableToday" },
  { label: "Unallocated & uncontacted", field: "unallocatedAndUncontacted" },
  { label: "With coaches", field: "allocatedToCoachUncontacted" },
  { label: "With Synthpop", field: "allocatedToSynthpopUncontacted" },
  { label: "Contacted today", field: "contactedToday" },
  { label: "Failed automation", field: "failedAutomation" }
];

const TotalCountsHeader = () => {
  const counts = useSelector(selectors.getGlobalCounts);

  if (!counts) return null;

  return (
    <div className="total-counts-header">
      {TILES.map(tile => (
        <div key={tile.field} className="count-tile">
          <span className="count-tile__value">{counts[tile.field] ?? 0}</span>
          <span className="count-tile__label">{tile.label}</span>
        </div>
      ))}
    </div>
  );
};

export default TotalCountsHeader;
